import { useEffect } from "react";
import ReferInput from "../ReferInput";
import { getUserDeptInfo } from "@src/services";
import { observer } from "mobx-react";
import { PAGE_MOD_ADD } from '../../utils/constants'
import { isDesigner } from "@src/utils/refer_context/formatter";
// import render from 'ynf-core-engine/render';
const DeptReferInput = (props) => {
  // const defaultProps={
  //   refCode: "ucf-org-center.bd_adminorgtreeref",
  //   refEntityUri: "bd.adminOrg.AdminOrgVO",
  //   refReturn: ["name"],
  //   refReturnArr: '{ "name": "formStore,dept_name" , "id": "formStore,dept" }',
  // }
  const { defaultValueType, pageStore } = props;
  const isAdd = pageStore?.status?.toUpperCase() === PAGE_MOD_ADD;
  // { value: "1", text: "制单人所在部门" },
  // { value: "2", text: "制单人所属组织" },
  // { value: "3", text: "上级主管部门" },
  // { value: "4", text: "自动填充上次已提交数据" },
  if (!isDesigner(props) && isAdd) {
    useEffect(async () => {
      if (defaultValueType) {
        const { data: res } = await getUserDeptInfo();
        if (res.code === "0") {
          let data = null
          if (defaultValueType === "1") {
            data = { id: res.data.deptId, name: res.data.deptName }
          } else if (defaultValueType === "2") {
            data = { id: res.data.orgId, name: res.data.orgName }
          } else if (defaultValueType === "3") {
            data = { id: res.data.parentDeptId, name: res.data.parentDeptName }
          }
          if (props.selectType === "multiple") {
            data = [data]
          }
          props.onChange(data)
        }
      }
    }, [defaultValueType]);
  }
  // eslint-disable-next-line react/react-in-jsx-scope
  return <ReferInput {...props}></ReferInput>;
};
export default observer(DeptReferInput);
